var exports = {
  "VQ": "x234b8571--c0c2c5--ratings",
  "F7": "x234b8571--c0c2c5--ratings__star",
  "Fv": "x234b8571--c0c2c5--ratings__label",
  "Yq": "x234b8571--c0c2c5--reviews",
};

module.exports = exports;
